var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultMultiField',{attrs:{"value":_vm.value,"document-value":_vm.documentValue,"question":_vm.question,"questions":_vm.question.config.fields}})}
var staticRenderFns = []

export { render, staticRenderFns }